module.exports = __webpack_public_path__ + "img/SEL_BG.69b0de08.svg";